/* eslint-disable import/prefer-default-export */
export const TOOLTIP_ITEM = 'js-tooltip';
export const ACTIVE_CLASS_NAME = 'active-tooltip';
